import classes from "./classes.module.scss";
import VersionFile from "@Front/version.json"; // TODO: This is a hack, we will use a proper versioning system stored in DB
import Typography, { ETypo, ETypoColor } from "../Typography";

export default function Version(): React.JSX.Element {
	return (
		<div className={classes["root"]}>
			<Typography typo={ETypo.TEXT_MD_REGULAR} color={ETypoColor.COLOR_NEUTRAL_500}>
				<div>{VersionFile.version}</div>
			</Typography>
		</div>
	);
}
